import useCompanyContext from 'common/hooks/useCompanyContext';
import useErrorHandledMutation from 'common/hooks/useErrorHandledMutation';

import { refetchQueryDirectDebitMandateCounts } from '../../../../../DirectDebitMandateList/hooks/useDirectDebitMandateCountsQuery';
import { refetchQueryDirectDebitMandates } from '../../../../../DirectDebitMandateList/hooks/useDirectDebitMandatesQuery';
import { UploadB2BDirectDebitMandateDocument } from './uploadB2BDirectDebitMandate.gql';

interface UploadB2BDirectDebitMandateResponse {
  uploadB2BDirectDebitMandate: {
    directDebitMandate: {
      directDebitMandateId: string;
    };
  };
}

interface UploadB2BDirectDebitMandateVariables {
  input: {
    bankAccountId: string;
    bucketName: string;
    creditorIdentifier: string;
    creditorName: string;
    fileRef: string;
    label: string;
    publicUrl: string;
    uniqueMandateReference: string;
    companyUserId: string;
  };
}

export function useUploadB2BDirectDebitMandate() {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error(
      'companyProfileId is required in useUploadB2BDirectDebitMandate',
    );
  }

  return useErrorHandledMutation<
    UploadB2BDirectDebitMandateResponse,
    UploadB2BDirectDebitMandateVariables
  >(UploadB2BDirectDebitMandateDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [
      refetchQueryDirectDebitMandates({ companyProfileId, isRevoked: true }),
      refetchQueryDirectDebitMandates({ companyProfileId, isRevoked: false }),
      refetchQueryDirectDebitMandateCounts({ companyProfileId }),
    ],
  });
}
